import { NgClass, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IRowNode } from 'ag-grid-community';
import { PlotAttributes } from '~app/models';
import { CellEditorComponent } from '../cell-editor/cell-editor.component';
type SaveBtnRendererParams = {
  onSaveClick: (rowNode: IRowNode) => any;
  getSaveAbility?: () => boolean;
  getRequiredFields?: () => any;
};

@Component({
  selector: 'ciao-save-btn-renderer',
  imports: [NgClass],
  template: `
    <button
      [ngClass]="{ disabled: !allowSave }"
      id="rowOption"
      class="semantic-button"
      tabindex="0"
      (click)="saveOnRow()"
    >
      <span>SAVE</span>
    </button>
  `,
  styles: `
    button {
      height: 30px;
      border-radius: 5px;
      border: 1px solid #006633;
      background-color: #E1F1D6;
      color: #006633;
      font-size: 10px;
      font-weight: 500;
      padding: 3px;
      margin: 8px 6px 8px 10px;
      &:hover {
        background-color: #006633;
        color: white;
      }
    }
  `,
})
export class SaveBtnComponent implements ICellRendererAngularComp {
  rowNode: IRowNode;
  params: ICellRendererParams & SaveBtnRendererParams;
  description: string;
  allowSave: boolean = false;
  agInit(params: ICellRendererParams<any, any> & SaveBtnRendererParams): void {
    this.params = params;
    this.rowNode = params?.node;
    this.allowSave = params?.getSaveAbility();
    this.refresh(params);
  }

  saveOnRow() {
    if (!this.allowSave) {
      let fields: string[] = this.params?.getRequiredFields();
      //check which of the fields is not valid
      const requiredFieldsThatAreEmpty: string[] = fields.filter(
        (key) => !(key in this.rowNode.data!) || this.rowNode.data![key] === ''
      );
      if (requiredFieldsThatAreEmpty.length !== 0) {
        this.params.api.flashCells({
          rowNodes: [this.rowNode],
          columns: [requiredFieldsThatAreEmpty[0]],
        });
        this.params.api.startEditingCell({
          rowIndex: 0,
          rowPinned: 'top',
          colKey: requiredFieldsThatAreEmpty[0],
        });

        // also need to get instance of cell editor so we can set field to dirty/touched
        let cell = this.params.api.getCellEditorInstances({
          rowNodes: [this.rowNode],
          columns: [requiredFieldsThatAreEmpty[0]],
        })[0];

        if (cell) {
          let renderer = cell as CellEditorComponent;
          renderer?.fieldControl?.markAsTouched();
          renderer?.fieldControl?.markAsDirty();
          renderer?.fieldControl.updateValueAndValidity();
        }
      }
      return;
    }
    if (this.params.onSaveClick) {
      this.params.onSaveClick(this.rowNode);
      return;
    }
  }

  refresh(params: ICellRendererParams<any, any, any> & SaveBtnRendererParams) {
    this.description = params.data?.description;
    this.allowSave = params?.getSaveAbility();
    return true;
  }

  get saveBtnImg() {
    return this.allowSave
      ? 'assets/img/trip-2.0/enabled-save-btn.svg'
      : 'assets/img/trip-2.0/disabled-save-btn.svg';
  }
}
